import { setNotification } from "features/Notification/notificationSlice";
import { createContext, useContext, useState } from "react";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";

const EfsInvoiceContext = createContext({});

export const EfsInvoiceProvider = ({ children }) => {
  const dispatch = useDispatch();

  /*   All States
   ********************************************* */
  const [selectedInv, setSelectedInv] = useState(null);

  /*   All Functions
   ********************************************* */
  // Get selected invoice details by id

  const GetInvById = async (invId) => {
    try {
      const { data } = await API.get("/manufacturer/efs-invoice/" + invId, {
        headers: authHeader(),
      });
      if (data?.success) {
        // Handle success scenario
        setSelectedInv(data?.data || null);
      } else {
        throw new Error(data?.message || "Failed to add project");
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        })
      );
    }
  };

  /*   All UseEffects
   ********************************************* */

  const efsInvoiceValues = {
    selectedInv,
    setSelectedInv,
    GetInvById,
  };
  return (
    <EfsInvoiceContext.Provider value={efsInvoiceValues}>
      {children}
    </EfsInvoiceContext.Provider>
  );
};

export default function useEfsInvoice() {
  return useContext(EfsInvoiceContext);
}
